import { Storage } from '@ionic/storage';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../../app/data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-banner-product',
  templateUrl: './slider-banner-product.component.html',
  styleUrls: ['./slider-banner-product.component.scss'],
})
export class SliderBannerProductComponent implements OnInit {
  bannerId:any;
  pro_array:any;
  cart_count:any;
  status:any;
  constructor(public storage:Storage, public restApi:DataService,public toastService:LoaderService, private route: ActivatedRoute, private router: Router,) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.bannerId))
      this.bannerId=JSON.parse(params.bannerId);
      this.status=JSON.parse(params.status);

    });
  }
ionViewWillEnter(){
  this.toastService.hideLoader()
  
  
    if(localStorage.getItem('cart_count')){
      this.cart_count=localStorage.getItem('cart_count');
    }else{
      this.cart_count='';
    }


    let postparams={
    bannerId:this.bannerId, 
    status:this.status
   }
   this.restApi.get_product_by_banner_slider(postparams).subscribe((data:any)=>{
    this.pro_array=data.pro_array;
    this.toastService.hideLoader()
    if(this.pro_array.length==0){
      this.toastService.create('Product not found!')
    }
   },(error:any)=>{
     this.toastService.hideLoader()
   })
}
goto_product_details(item){
  let product_id=item.product_id
  let navigationExtras: NavigationExtras = {
    queryParams: {
      product_id: JSON.stringify(product_id),
    }
  };
  console.log(item.product_id);
  //routerLink="/productdetails"
  this.router.navigate(['/productdetails'], navigationExtras); 
}
}
